import { colors } from '../../../packages';
import { makeStyles } from '@mui/styles';

export const sxStyles = {
  container: {
    width: '100%',
    height: 'calc(100vh - 17vh)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.neutral50,
  },
  textDecoration: {
    textDecoration: 'none',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    marginTop: '30px',
  },
  headerTitle: {
    fontSize: '28px',
  },
  markReviewedButton: {
    borderRadius: '4px',
    height: '40px',
    textTransform: 'none',
    fontSize: '16px',
  },
  pdfContainer: {
    flex: 1,
    backgroundColor: colors.white,
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
};

export const useStyles = makeStyles({
  baseLayout: {
    position: 'relative',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 110,
    height: 60,
    width: '100vw',
    borderBottom: `1px solid ${colors.neutral100}`,
    paddingLeft: 200,
    paddingRight: 100,
    display: 'flex',
    alignItems: 'center',
  },
});
